export var RECORD_TYPES_FILTER_KEY = 'record_types';
